import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import useEscapeKey from "../../hooks/useEscapeKey";
import Button from "../Button/Button";
import "./ConfirmModal.css";

const ConfirmModal = ({ title, message, confirmLabel = "Delete", onConfirm, onCancel }) => {
  const cancelRef = useRef(null);

  useEffect(() => {
    cancelRef.current?.focus();
  }, []);

  useEscapeKey(onCancel);

  return createPortal(
    <div
      className="modal-backdrop"
      onClick={(e) => { e.stopPropagation(); onCancel(); }}
      aria-modal="true"
      role="dialog"
      aria-labelledby="modal-title"
    >
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h3 id="modal-title" className="modal-title">{title}</h3>
        <p className="modal-message">{message}</p>
        <div className="modal-actions">
          <Button variant="secondary" size="sm" ref={cancelRef} onClick={onCancel}>Cancel</Button>
          <Button variant="primary" size="sm" danger onClick={onConfirm}>{confirmLabel}</Button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmModal;
